import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Box } from '@mui/material';
import theme from './theme';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import DashboardLayout from './components/DashboardLayout';
import Home from './pages/Home';
import Register from './pages/Register';
import Login from './pages/Login';
import Pricing from './pages/Pricing';
import Payment from './pages/Payment';
import ApiDocs from './pages/ApiDocs';
import Support from './pages/Support';
import Profile from './pages/dashboard/Profile';
import Usage from './pages/dashboard/Usage';
import ApiKeys from './pages/dashboard/ApiKeys';
import Billing from './pages/dashboard/Billing';
import PaymentSummary from './pages/dashboard/PaymentSummary';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <Routes>
            {/* Public Routes with Navigation and Footer */}
            <Route path="/" element={
              <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
                <Navigation />
                <Home />
                <Footer />
              </Box>
            } />
            <Route path="/register" element={
              <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
                <Navigation />
                <Register />
                <Footer />
              </Box>
            } />
            <Route path="/login" element={
              <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
                <Navigation />
                <Login />
                <Footer />
              </Box>
            } />
            <Route path="/forgot-password" element={
              <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
                <Navigation />
                <ForgotPassword />
                <Footer />
              </Box>
            } />
            <Route path="/reset-password" element={
              <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
                <Navigation />
                <ResetPassword />
                <Footer />
              </Box>
            } />
            <Route path="/pricing" element={
              <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
                <Navigation />
                <Pricing />
                <Footer />
              </Box>
            } />
            <Route path="/payment" element={
              <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
                <Navigation />
                <Payment />
                <Footer />
              </Box>
            } />
            <Route path="/api-docs" element={
              <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
                <Navigation />
                <ApiDocs />
                <Footer />
              </Box>
            } />
            <Route path="/support" element={
              <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
                <Navigation />
                <Support />
                <Footer />
              </Box>
            } />

            {/* Protected Dashboard Routes */}
            <Route path="/dashboard/profile" element={
              <ProtectedRoute>
                <DashboardLayout>
                  <Profile />
                </DashboardLayout>
              </ProtectedRoute>
            } />
            <Route path="/dashboard/usage" element={
              <ProtectedRoute>
                <DashboardLayout>
                  <Usage />
                </DashboardLayout>
              </ProtectedRoute>
            } />
            <Route path="/dashboard/api-keys" element={
              <ProtectedRoute>
                <DashboardLayout>
                  <ApiKeys />
                </DashboardLayout>
              </ProtectedRoute>
            } />
            <Route path="/dashboard/billing" element={
              <ProtectedRoute>
                <DashboardLayout>
                  <Billing />
                </DashboardLayout>
              </ProtectedRoute>
            } />
            <Route path="/dashboard/payment-summary" element={
              <ProtectedRoute>
                <DashboardLayout>
                  <PaymentSummary />
                </DashboardLayout>
              </ProtectedRoute>
            } />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
